import { render } from "./StockInternalTransfersTable.vue?vue&type=template&id=0a1e9516&scoped=true"
import script from "./StockInternalTransfersTable.vue?vue&type=script&lang=js"
export * from "./StockInternalTransfersTable.vue?vue&type=script&lang=js"

import "./StockInternalTransfersTable.vue?vue&type=style&index=0&id=0a1e9516&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a1e9516"]])

export default __exports__